export default __webpack_public_path__ + "static/media/toggle-left.2376fb9b.svg";